/// <reference types="./global" />
import "react-app-polyfill/ie9"
import "react-app-polyfill/stable"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./utils/sensors"

declare let VConsole: any

/** 如果需要支持rem的兼容处理，50px=1rem */
if (document.getElementById("viewport")?.getAttribute("content")?.includes("device-width")) {
  let fontSize = (window.innerWidth / 375) * 50 + "px"
  document.documentElement.style.setProperty("font-size", fontSize)
  window.onresize = () => {
    fontSize = (window.innerWidth / 375) * 50 + "px"
    document.documentElement.style.setProperty("font-size", fontSize)
  }
}

/** 非生产环境引入vconsole调试 */
if (process.env.REACT_APP_ENV !== "prod") {
  let script = document.createElement("script")
  script.src = "https://unpkg.com/vconsole@latest/dist/vconsole.min.js"
  document.head.appendChild(script)
  const vc_timer: any = setInterval(() => {
    try {
      new VConsole()
      clearInterval(vc_timer)
    } catch {}
  }, 100)
}

const container = document.getElementById("root")!
const root = createRoot(container)
const params = Array.from(new URL(window.location.href).searchParams.entries())
params.forEach(([key, value]) => {
  if (key === "headers") {
    localStorage.setItem("YP_HEADERS", value)
  }
})

root.render(
  <BrowserRouter basename="/h5/">
    <App />
  </BrowserRouter>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
